<div class="toast-msg">
  <div class="toast-icon">
    <img src="assets/images/toast-icon.svg" alt="icon" *ngIf="message != 'Skin Test will be live soon!'">
    <img src="assets/images/clock-toast.svg" alt="icon" *ngIf="message == 'Skin Test will be live soon!'">
  </div>
  <span>
    {{message}}
  </span>
</div>